import { Component } from '@angular/core';
import { DcService } from './dc.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';
import { VcaAlertsService } from '../../../../common/vca-alerts/vca-alerts.service';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../refresh-shared-service';
import { AuthService } from '../../../auth/auth.service';
const _ = require('lodash');

@Component({
    selector: 'deployment-container-landing',
    styles: [require('./dc.scss')],
    templateUrl: './dc-landing.html',
    providers: [DcService]
})

export class DeploymentContainerLanding {
    private deploymentContainerData: any = [];
    private isTranslationready: boolean = true;
    private isLoading: boolean = true;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';
    private canAdd: boolean = true;
    private canDelete: boolean = false;
    private canEdit: boolean = false;
    private isAddEditDialogOpen: boolean = false;
    private isEditInProgress: boolean = false;
    private isReadOnly: boolean = true;
    private selectedDeploymentContainer: any;
    private showDeleteDialog: boolean = false;
    private editData: any;
    private isEdit: boolean = false;
    private vcList: Array<Object>
    private isSystemAdmin: boolean = false;
    private isGlobalDeploymentContainer: boolean = false;
    private globalDeploymentContainerVc: string = '';
    constructor(private service: DcService,
                private translate: TranslateService,
                private alert: VcaAlertsService,
                private rss: RefreshSharedService,
                public authService: AuthService) {
        translate.use(GlobalVariables.LOCALE);
        this.rsService = rss;
        this.currentClassName = 'DeploymentContainerLanding';
        let roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];
        if (_.includes(roles, 'System Administrator')) {
            this.isSystemAdmin = true;
        }
    }

    ngOnInit() {
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
          this.handleEmittedValues(item);
        });

        this.rsService.setParam({
            'loadedComponent': this.currentClassName,
            'detailPageIDName': '',
            'shouldReloadInventoryTree': false
        });
        this.getAllVCs();
    }

    handleEmittedValues(item) {
        this.getAllVCs();
    }

    getAllVCs() {
        this.vcList = [];
        this.isLoading = true;
        this.service.getVcList()
        .subscribe(
            (data: any) => {
                this.vcList = data;
                this.isLoading = false;
                this.getDeploymentContainers();
            },
            error => {
                this.alert.danger(['Failed to retrieve VCenters', error], 'vcenter-grid');
                this.isLoading = false;
            }
        );
    }

    getDeploymentContainers() {
        if (!this.vcList || this.vcList.length === 0) {
            return;
        }
        this.isGlobalDeploymentContainer = false;
        this.globalDeploymentContainerVc = '';
        if (this.isSystemAdmin) {
            this.getDeploymentContainersForEdit();
        } else {
            let __this = this;
            this.deploymentContainerData = [];
            this.vcList.forEach(function (item) {
                __this.getDeploymentContainersForReadOnly(item['vcenter_instanceId']);
            })
        }
    }

    getDeploymentContainersForEdit() {
        let __this = this;
        this.deploymentContainerData = [];
        this.isLoading = true;
        this.service.getDeploymentContainersForEdit()
            .subscribe(
                (data: any) => {
                    data.forEach(function(item) {
                        if (item.isGlobal){
                            __this.isGlobalDeploymentContainer = true;
                            __this.globalDeploymentContainerVc = item.vCenterInstanceUuid ? item.vCenterInstanceUuid : '';
                        }
                    })
                    this.deploymentContainerData = data;
                    this.isLoading = false;
                },
                error => {
                    this.alert.danger(['Failed to retrieve VCenters', error], 'vcenter-grid');
                    this.isLoading = false;
                }
            );
    }

    isDeploymentContainerPresent(dcToAdd) {
        if (this.deploymentContainerData.length === 0) {
            return false;
        }
        for (let i = 0; i < this.deploymentContainerData.length; i++) {
            if (this.deploymentContainerData[i].id === dcToAdd.id) {
                return true;
            }
        }
        return false;
    }

    getDeploymentContainersForReadOnly(scopeId) {
        this.isLoading = true;
        let __this = this;
        this.service.getDeploymentContainersForReadOnly(scopeId)
        .subscribe(
            (data: any) => {
                if (data && data.length > 0) {
                    data.forEach(function(item) {
                        if (!__this.isDeploymentContainerPresent(item)) {
                            __this.deploymentContainerData.push (item);
                        }
                    })
                }
                this.isLoading = false;
            },
            error => {
                this.alert.danger(['Failed to retrieve VCenters', error], 'vcenter-grid');
                this.isLoading = false;
            }
        );
    }

    ngOnDestroy() {
        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }

    // Add / Edit Action
    onCreate(event) {
        this.isAddEditDialogOpen = true;
        this.isEdit = false;
        this.editData = {};
    }

    onEditMenuClick(deploymentContainer) {
        this.isEdit = true;
        this.editData = deploymentContainer
        this.selectedDeploymentContainer = deploymentContainer;
        this.isAddEditDialogOpen = true;
    }

    onCancelDeploymentContainer(event) {
        this.isAddEditDialogOpen = false;
    }
    onSaveDeploymentContainer(event) {
        this.getDeploymentContainers();
        this.isAddEditDialogOpen = false;
    }

    // Delete Action
    onDeleteMenuClick(deploymentContainer) {
        this.selectedDeploymentContainer = deploymentContainer;
        this.showDeleteDialog = true;
    }
    onDeleteDialogCancel(event) {
        this.showDeleteDialog = false;
    }
    onDeleteDialogSave(id) {
        this.showDeleteDialog = false;
        this.isEditInProgress = true;
        this.isLoading = true;
        this.service.deleteDeploymentContainer(id).subscribe(
            () => {
                this.isEditInProgress = false;
                this.isReadOnly = true;
                this.isLoading = false;
                this.getDeploymentContainers();
                this.getAllVCs()
            },
            error => {
                this.isEditInProgress = false;
                this.isLoading = false;
                console.log('failed to delete Deployment Container', error);
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/administration-main/deployment-container/dc-landing.component.ts